module.exports = __webpack_public_path__ + "static/media/educat-logo.23895114.svg";